module.exports = __webpack_public_path__ + "img/nlp-5g-col.jpg";